/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ThumbUpIcon = ({ width = 24, height = 24, hidden = false, title = 'Thumb Up' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="18" rx="1" ry="1" width="6" x="2" y="14" />
    <path
      d="M30.967 14H21a54.94 54.94 0 0 0 1-9.08C22 3.259 20.968 2 20 2a1.839 1.839 0 0 0-2 2 11.326 11.326 0 0 1-2.516 6.258A46.35 46.35 0 0 1 10 15.042V30s2.809-.033 14 0a3.946 3.946 0 0 0 3.677-2.424l5.128-10.788A2 2 0 0 0 30.967 14Z"
    />
  </svg>`;
};
